import { atom } from 'jotai';
export const $Traffic = atom({
    href: '',
    pid: '',
});
$Traffic.debugLabel = '$Traffic';
//# sourceMappingURL=traffic.js.map